import state from './state/state';
import getters from './getters/getters';
import mutations from './mutations/mutations';
import actions from './actions/actions';

//
export default {
  state,
  getters,
  mutations,
  actions
};
